import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

@Component({
  name: 'ValueView',
})
export default class ValueView extends Vue {
  @Prop({type: String, default: ''}) public readonly name!: string;
  @Prop({type: [String, Number], default: ''}) public readonly value!: string | number;
  @Prop({type: Boolean, default: false}) public readonly vertical!: boolean;
  @Prop({type: String, default: 'pre'}) public readonly tag!: string;

  private render(createElement: CreateElement): VNode {
    return createElement('div', {
      class: {
        'display-f': true,
        'flex-column': this.vertical,
      },
    }, [
      createElement('p', { class: ['p5', 'flex-3']}, this.name),
      createElement(this.tag, { class: ['flex-3', 'p']}, `${this.value}`),
    ]);
  }
}
